import React, { Component } from 'react';

const jumbotronStyles = {
    backgroundColor: '#529a76'
}

export default class Jumbotron extends Component {
  componentDidMount(){
    console.log(this.props);
  }
  render() {

    var classStyles = '';
    if (this.props.capitalize) classStyles += 'capitalize';

    return (
      <div style={jumbotronStyles} className="jumbotron jumbotron-fluid">
        <div className="container">
          
          <p className="jumbotron-detalhe">{this.props.detalhe}</p>
          
          
          <h1 className="jumbotron-text">{this.props.title}</h1>
        </div>
      </div>
    )
  }
}
